import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import palette from 'theme/palette';

export const BootstrapTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: palette.primary.main,
    color: '#fff',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    padding: '6px 8px',
    borderRadius: '20px',
    position: 'relative',
    top: '-10px',
  },
}));

export const SwitchTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    maxWidth: 480,
    minWidth: 360,
    borderRadius: '20px',
    boxShadow: '0 10px 40px 0 rgb(0 0 0 / 8%)',
    position: 'relative',
    left: '24px',
  },
}));
